<section [formGroup]="checkboxGroupForm" >  
    @for(option of options; track option.value) {
        <section class="checkbox">
            @if(getLabelPosition(option) === 'before') {
                @if(option.icon) {
                    @for(icon of this.getIcons(option.icon); track icon) {
                        <lib-app-icon class="pr-[10px]" [icon]="icon" matSuffix [size]="getIconSize(option)" />
                    }
                }
                <div [class]="className" class="flex items-center">
                    <mat-label [class]="labelClassName">{{option.viewValue}}</mat-label>
                    <mat-checkbox class="mat-checkbox" [disabled]="areCheckboxesDisabled" [formControlName]="getCheckboxValue(option)"
                        [id]="getCheckboxValue(option)" [value]="getCheckboxValue(option)"></mat-checkbox>
                </div>
            }
            
            @if(getLabelPosition(option) === 'after') {
                <div [class]="className" class="flex items-center">
                    <mat-checkbox
                        class="mat-checkbox"
                        [disabled]="areCheckboxesDisabled"
                        [formControlName]="getCheckboxValue(option)"
                        [id]="getCheckboxValue(option)"
                        [value]="getCheckboxValue(option)"
                        color="primary"
                    />

                    @if(option.icon) {
                        <lib-app-icon class="pr-[10px]" [icon]="getIcon(option) || ''" matSuffix [size]="getIconSize(option)" />
                    }

                    <mat-label [class]="labelClassName">{{option.viewValue}}</mat-label>

                </div>
            }

            @if(includeDividers && options && option !== options[options.length - 1]) {
                <mat-divider></mat-divider>
            }
        </section>
    }
</section>
  